import React from 'react';
import { createPortal } from 'react-dom';

interface CustomPortalProps {
  children: React.ReactNode;
  isOpen: boolean;
}

const CustomPortal: React.FC<CustomPortalProps> = ({ children, isOpen }) => {
  if (!isOpen) return null;
  
  return createPortal(
    <>{children}</>,
    document.body
  );
};

export default CustomPortal; 